module.exports = __webpack_public_path__ + "static/img/LlnkedinSquareReverse.f7cd32c1.svg";